import { useState, createContext } from 'react';

const A11yStateContext = createContext([null, () => {}]);

const A11yStateProvider = ({ children }) => {
  const [activeTooltipId, setActiveTooltipId] = useState(null);

  return (
    <A11yStateContext.Provider value={[activeTooltipId, setActiveTooltipId]}>
      {children}
    </A11yStateContext.Provider>
  );
};

A11yStateProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { A11yStateContext, A11yStateProvider };
